import { DevSeedsNamespace } from "./dev/seeds.js";
class DevNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    this.connection = this.clientOrParent.connection;
    this.seeds = new DevSeedsNamespace(this);
  }
}
export {
  DevNamespace
};
//# sourceMappingURL=dev.js.map
